import {
  SlAlert
} from "./chunk.6UPB6RWT.js";

// src/components/alert/alert.ts
var alert_default = SlAlert;
SlAlert.define("sl-alert");

export {
  alert_default
};
